module.exports = __webpack_public_path__ + "img/logo-fgc.d9a9b6c2.png";